
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
//import NavDropdown from 'react-bootstrap/NavDropdown';
//import topbg from '../images/testbackground.png';


/*
Please note that there is 2 top menus. TopMenu which is the top menu for most pages, and TopMenuHome which is the top menu for the homepage.
I did this as I wanted to change the topmenu specifically for the home page.    
*/
function NavbarComponent() {
    const location = useLocation(); //gets url path for navbar to know what is active

    return (
        <div>
            <Navbar fixed="top" expand="md" id="custom-nav" className="px-0">

                <Container fluid className="px-0">
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center m-auto">
                        <Nav>
                            <Nav.Link as={Link} to="/" className={location.pathname === '/' ? 'active-nav-link' : ''}>Home</Nav.Link>
                            <Nav.Link as={Link} to="/about" className={location.pathname === '/about' ? 'active-nav-link' : ''}>About</Nav.Link>
                            <NavDropdown title="Trucks" className={location.pathname === '/peterbilt' ? 'active-dropdown-link' : '' || location.pathname === '/isuzu' ? 'active-dropdown-link' : '' || location.pathname === '/mcneilus' ? 'active-dropdown-link' : '' || location.pathname === '/custom-truck' ? 'active-dropdown-link' : ''}>
                                <NavDropdown.Item as={Link} to="/peterbilt">
                                    Peterbilt
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/isuzu">
                                    Isuzu
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/mcneilus">
                                    McNeilus
                                </NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item as={Link} to="/custom-truck">
                                    Custom
                                </NavDropdown.Item>
                            </NavDropdown>
                            <Nav.Link as={Link} to="/service" className={location.pathname === '/service' ? 'active-nav-link' : ''}>Service</Nav.Link>
                            <Nav.Link as={Link} to="/parts" className={location.pathname === '/parts' ? 'active-nav-link' : ''}>Parts</Nav.Link>
                            <Nav.Link as={Link} to="/affiliates" className={location.pathname === '/affiliates' ? 'active-nav-link' : ''}>Affiliates</Nav.Link>
                            <Nav.Link as={Link} to="/contact" className={location.pathname === '/contact' ? 'active-nav-link' : ''}>Contact</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container >
            </Navbar>
            <div style={{
                height: '75px',
            }} />

        </div>
    );
}

export default NavbarComponent;

//<Nav.Link as={Link} to="/affiliates" className={location.pathname === '/affiliates' ? 'active-nav-link' : ''}>Affiliates</Nav.Link>